import { render } from "./Empleados.vue?vue&type=template&id=9a5798ea&scoped=true"
import script from "./Empleados.vue?vue&type=script&lang=js"
export * from "./Empleados.vue?vue&type=script&lang=js"

import "./Empleados.vue?vue&type=style&index=0&id=9a5798ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5798ea"]])

export default __exports__